import { createWebHistory, createRouter } from "vue-router";
/* Layout */
import Layout from "@/layout";
import Layout2 from "@/layout/index2.vue";
/**
 * Note: 路由配置项
 *
 * hidden: true                     // 当设置 true 的时候该路由不会再侧边栏出现 如401，login等页面，或者如一些编辑页面/edit/1
 * alwaysShow: true                 // 当你一个路由下面的 children 声明的路由大于1个时，自动会变成嵌套的模式--如组件页面
 *                                  // 只有一个时，会将那个子路由当做根路由显示在侧边栏--如引导页面
 *                                  // 若你想不管路由下面的 children 声明的个数都显示你的根路由 
 *                                  // 你可以设置 alwaysShow: true，这样它就会忽略之前定义的规则，一直显示根路由
 * redirect: noRedirect             // 当设置 noRedirect 的时候该路由在面包屑导航中不可被点击
 * name:'router-name'               // 设定路由的名字，一定要填写不然使用<keep-alive>时会出现各种问题
 * query: '{"id": 1, "name": "ry"}' // 访问路由的默认传递参数
 * roles: ['admin', 'common']       // 访问路由的角色权限
 * permissions: ['a:a:a', 'b:b:b']  // 访问路由的菜单权限
 * meta : {
    noCache: true                   // 如果设置为true，则不会被 <keep-alive> 缓存(默认 false)
    title: 'title'                  // 设置该路由在侧边栏和面包屑中展示的名字
    icon: 'svg-name'                // 设置该路由的图标，对应路径src/assets/icons/svg
    breadcrumb: false               // 如果设置为false，则不会在breadcrumb面包屑中显示
    activeMenu: '/system/user'      // 当路由设置了该属性，则会高亮相对应的侧边栏。
  }
 */

// 公共路由
export const constantRoutes = [
  {
    path: "/",
    redirect: "/login",
    hidden: true,
  },
  {
    path: "/login",
    component: () => import("@/views/login/login.vue"),
    hidden: true,
  },
  {
    path: "/register",
    component: () => import("@/views/login/register.vue"),
    hidden: true,
  },
  {
    path: "/home",
    component: Layout2,
    hidden: true,
    children: [
      {
        path: "/home/tenantindex",
        component: () => import("@/views/home/tenantindex.vue"),
        name: "tenantindex",
        meta: { title: "首页", icon: "dashboard", affix: true },
      },
      {
        path: "/home/enterpriseindex",
        component: () => import("@/views/home/enterpriseindex.vue"),
        name: "enterpriseindex",
        meta: { title: "首页", icon: "dashboard", affix: true },
      }
    ],
  },
  {
    path: "/securityUser",
    component: Layout2,
    hidden: true,
    children: [
      {
        path: "/securityUser/edit",
        component: () => import("@/views/securityUser/edit.vue"),
        name: "安全员备案",
        meta: {
          title: "安全员备案",
          icon: "icon-cheliangguanliicon",
        },
      }
    ],
  },
  {
    path: "/business",
    component: Layout2,
    hidden: true,
    children: [
      {
        path: "/business/task-add",
        component: () => import("@/views/business/task/add.vue"),
        name: "TaskAdd",
        hidden: true,
        meta: { title: "任务新增", icon: "dashboard" },
      },
      {
        path: "/business/task-detail",
        component: () => import("@/views/business/task/detail.vue"),
        name: "TaskDetail",
        hidden: true,
        meta: { title: "任务详情", icon: "dashboard" },
      },
      {
        path: "/business/task-review",
        component: () => import("@/views/business/task/review.vue"),
        name: "TaskReview",
        hidden: true,
        meta: { title: "任务审核", icon: "dashboard" },
      }
    ],
  },
  {
    path: "/vehicle",
    component: Layout2,
    hidden: true,
    children: [
      {
        path: "/vehicle/filing",
        component: () => import("@/views/vehicle/edit.vue"),
        name: "vehicle-filing",
        meta: { title: "车辆报备", icon: "dashboard", affix: true },
      },
      {
        path: "/vehicle/detail",
        component: () => import("@/views/vehicle/detail.vue"),
        name: "vehicle-detail",
        meta: { title: "车辆详情", icon: "dashboard", affix: true },
      }
    ],
  },
  {
    path: "/supervise",
    component: Layout2,
    hidden: true,
    children: [
      {
        path: "/supervise/dynamic",
        component: () => import("@/views/test/monitor/index.vue"),
        name: "supervise-dynamic",
        meta: { title: "动态监管", icon: "dashboard", affix: true },
      },
      {
        path: "/supervise/dynamic/detail",
        component: () => import("@/views/test/monitor/detail.vue"),
        name: "supervise-vehicle-detail",
        meta: { title: "车辆监管", icon: "dashboard", affix: true },
      }
    ],
  },
  {
    path: "/about",
    component: Layout2,
    hidden: true,
    children: [
      {
        path: "/about/index",
        component: () => import("@/views/about/index.vue"),
        name: "AboutIndex",
        meta: { title: "机构简介", icon: "dashboard", affix: true },
      }
    ],
  },
  {
    path: "/open_roads",
    component: Layout2,
    hidden: true,
    children: [
      {
        path: "/open_roads/index",
        component: () => import("@/views/roads/index.vue"),
        name: "OpenRoadsIndex",
        meta: { title: "开放道路", icon: "dashboard", affix: true },
      }
    ],
  },
  {
    path: "/news",
    component: Layout2,
    hidden: true,
    children: [
      {
        path: "/news/index",
        component: () => import("@/views/news/index.vue"),
        name: "NewsIndex",
        meta: { title: "工作动态", icon: "dashboard", affix: true },
      },
      {
        path: "/news/about",
        component: () => import("@/views/about/index.vue"),
        name: "NewsAboutIndex",
        meta: { title: "机构简介", icon: "dashboard", affix: true },
      },
      {
        path: "/news/news",
        component: () => import("@/views/news/news.vue"),
        name: "NewsManage",
        meta: { title: "工作动态", icon: "dashboard", affix: true },
      }
    ],
  },
  {
    path: "/:pathMatch(.*)*",
    component: () => import("@/views/error/404"),
    hidden: true,
  },
  {
    path: "/401",
    component: () => import("@/views/error/401"),
    hidden: true,
  },
  {
    path: '/enterpriseManage',
    component: Layout,
    hidden: true,
    redirect: 'enterpriseManage',
    children: [
      {
        path: '/enterpriseManage/enterprise',
        component: () => import('@/views/enterprise/index.vue'),
        name: 'enterprise',
        hiddent: true,
        meta: { title: '企业注册审核', icon: 'dashboard', affix: true }
      },
      {
        path: '/enterpriseManage/review',
        component: () => import('@/views/enterprise/review.vue'),
        name: 'enterpriseReview',
        hiddent: true,
        meta: { title: '企业注册审核', icon: 'dashboard', affix: true }
      },
    ]
  },
  {
    path: "/carManage1",
    component: Layout,
    hidden: true,
    redirect: "noredirect",
    children: [
      {
        path: "/carManage1/audit",
        component: () => import("@/views/car/audit"),
        name: "信息变更审核",
        meta: {
          title: "车辆管理/信息变更审核",
          icon: "icon-cheliangguanliicon",
        },
      },
    ],
  },
  {
    path: "/testManage/realtimeMonitorA",
    component: Layout2,
    hidden: true,
    redirect: "/testManage/realtimeMonitorB",
  },
  {
    path: "/testManage",
    component: Layout2,
    hidden: true,
    children: [
      {
        path: "/testManage/videoMonitor",
        component: () => import("@/views/test/monitor/videomonitor.vue"),
        name: "视频监控",
        meta: {
          title: "视频监控",
          icon: "icon-cheliangguanliicon",
        },
      },
      {
        path: "/test/monitor/screensetting",
        component: () => import("@/views/test/monitor/components/ScreenSettings.vue"),
        name: "ScreenSettings",
        meta: {
          title: "屏幕设置详情",
        },
      },
      {
        path: "/test/monitor/screenmonitor",
        component: () => import("@/views/test/monitor/screenmonitor.vue"),
        name: "ScreenMonitor",
        meta: {
          title: "屏幕监控",
        },
      },
      {
        path: "/testManage/data/statistic",
        //component: () => import("@/views/test/realtimeMonitor"),
        component: () => import("@/views/test/data/statistic.vue"),
        name: "数据统计",
        meta: {
          title: "数据统计",
          icon: "icon-cheliangguanliicon",
        },
      },
      {
        path: "/testManage/data/analysis",
        //component: () => import("@/views/test/realtimeMonitor"),
        component: () => import("@/views/test/data/analysis.vue"),
        name: "数据分析",
        meta: {
          title: "数据分析",
          icon: "icon-cheliangguanliicon",
        },
      },
    ],
  },
  
  {
    path: "/testManage/testPathA",
    component: Layout2,
    hidden: true,
    redirect: "/testManage/testPathB",
  },

  {
    path: "/testManage",
    component: Layout2,
    hidden: true,
    children: [
      {
        path: "/testManage/testPathB",
        component: () => import("@/views/test/testPath"),
        name: "测试路线",
        meta: {
          title: "测试路线",
          icon: "icon-cheliangguanliicon",
        },
      }
    ],
  },
  {
    path: "/announcement",
    component: Layout2,
    hidden: true,
    children: [
      {
        path: "/announcement/list",
        component: () => import("@/views/announcement/list.vue"),
        name: "AnnouncementList",
        meta: { title: "政策公告", icon: "dashboard", affix: true },
      },
      {
        path: "/announcement/detail",
        component: () => import("@/views/announcement/detail.vue"),
        name: "AnnouncementDetail",
        hidden: true,
        meta: { title: "公告详情", icon: "dashboard" },
      },
      {
        path: "/announcement/index",
        component: () => import("@/views/announcement/index.vue"),
        name: "AnnouncementIndex",
        hidden: true,
        meta: { title: "政策公告", icon: "dashboard" },
      },
      {
        path: "/announcement/edit",
        component: () => import("@/views/announcement/edit.vue"),
        name: "AnnouncementEdit",
        hidden: true
      }
    ],
  },
  {
    path: "/zone",
    component: Layout2,
    hidden: true,
    children: [
      {
        path: "/zone/index",
        component: () => import("@/views/zone/index.vue"),
        name: "ZoneIndex",
        meta: { title: "测试区域", icon: "dashboard", affix: true },
      },
      {
        path: "/zone/detail",
        component: () => import("@/views/zone/detail.vue"),
        name: "ZoneDetail",
        hidden: true,
        meta: { title: "测试区域详情", icon: "dashboard" },
      },
      {
        path: "/zone/edit",
        component: () => import("@/views/zone/edit.vue"),
        name: "ZoneEdit",
        hidden: true
      },
      {
        path: "/zone/dashboardMockData",
        component: () => import("@/views/zone/dashboardMockData.vue"),
        name: "ZoneDashboardMockData",
        hidden: true
      }
    ],
  },
  {
    path: "/notice",
    component: Layout2,
    hidden: true,
    children: [
      {
        path: "/notice/index",
        component: () => import("@/views/notice/index.vue"),
        name: "NoticeIndex",
        meta: { title: "通知", icon: "dashboard", affix: true },
      }
    ],
  },
  {
    path: "/application",
    component: Layout,
    hidden: true,
    children: [
      {
        path: "/application/reviewMeeting",
        component: () => import("@/views/application/review/reviewMeetings.vue"),
        name: "ReviewMeeting",
        meta: { title: "评审会议", icon: "dashboard", affix: true },
      }
    ],
  },
  {
    path: "/test",
    component: Layout,
    hidden: true,
    children: [
      {
        path: "/test/alarm",
        component: () => import("@/views/test/alarm/index.vue"),
        name: "AlarmIndex",
        meta: { title: "告警中心", icon: "dashboard", affix: true },
      },
      {
        path: "/test/alarm/detail",
        component: () => import("@/views/test/alarm/detail.vue"),
        name: "AlarmDetail",
        hidden: true,
        meta: { title: "告警详情", icon: "dashboard" },
      }
    ],
  },
  {
    path: "/report",
    component: Layout,
    hidden: true,
    children: [
      {
        path: "/report/testing",
        component: () => import("@/views/report/testing/index.vue"),
        name: "TestingReportIndex",
        meta: { title: "测试报告", icon: "dashboard", affix: true },
      },
      {
        path: "/report/testing/detail",
        component: () => import("@/views/report/testing/detail.vue"),
        name: "TestingReportDetail",
        hidden: true,
        meta: { title: "测试报告详情", icon: "dashboard" },
      },
      {
        path: "/report/incident/edit",
        component: () => import("@/views/report/incident/edit.vue"),
        name: "IncidentReportEdit",
        hidden: true,
        meta: { title: "上传事故报告", icon: "dashboard" },
      },
      {
        path: "/report/incident/detail",
        component: () => import("@/views/report/incident/detail.vue"),
        name: "IncidentReportDetail",
        hidden: true,
        meta: { title: "事故报告详情", icon: "dashboard" },
      }
    ],
  }
];

// 动态路由，基于用户权限动态去加载
export const dynamicRoutes = [
  // {
  //   path: '/system/user-auth',
  //   component: Layout,
  //   hidden: true,
  //   permissions: ['system:user:edit'],
  //   children: [
  //     {
  //       path: 'role/:userId(\\d+)',
  //       component: () => import('@/views/system/user/authRole'),
  //       name: 'AuthRole',
  //       meta: { title: '分配角色', activeMenu: '/system/user' }
  //     }
  //   ]
  // },
  // {
  //   path: '/system/role-auth',
  //   component: Layout,
  //   hidden: true,
  //   permissions: ['system:role:edit'],
  //   children: [
  //     {
  //       path: 'user/:roleId(\\d+)',
  //       component: () => import('@/views/system/role/authUser'),
  //       name: 'AuthUser',
  //       meta: { title: '分配用户', activeMenu: '/system/role' }
  //     }
  //   ]
  // },
  // {
  //   path: '/system/dict-data',
  //   component: Layout,
  //   hidden: true,
  //   permissions: ['system:dict:list'],
  //   children: [
  //     {
  //       path: 'index/:dictId(\\d+)',
  //       component: () => import('@/views/system/dict/data'),
  //       name: 'Data',
  //       meta: { title: '字典数据', activeMenu: '/system/dict' }
  //     }
  //   ]
  // },
  // {
  //   path: '/monitor/job-log',
  //   component: Layout,
  //   hidden: true,
  //   permissions: ['monitor:job:list'],
  //   children: [
  //     {
  //       path: 'index/:jobId(\\d+)',
  //       component: () => import('@/views/monitor/job/log'),
  //       name: 'JobLog',
  //       meta: { title: '调度日志', activeMenu: '/monitor/job' }
  //     }
  //   ]
  // },
  // {
  //   path: '/tool/gen-edit',
  //   component: Layout,
  //   hidden: true,
  //   permissions: ['tool:gen:edit'],
  //   children: [
  //     {
  //       path: 'index/:tableId(\\d+)',
  //       component: () => import('@/views/tool/gen/editTable'),
  //       name: 'GenEdit',
  //       meta: { title: '修改生成配置', activeMenu: '/tool/gen' }
  //     }
  //   ]
  // }
];

const router = createRouter({
  history: createWebHistory(),
  routes: constantRoutes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return { top: 0 };
    }
  },
});

export default router;
